<template>
  <!--bottom -->
  <div style="background: #373B41;min-width: 1200px; margin: 0px auto;" >
      <div style="width: 1200px;margin:0 auto;padding:20px 0px;display: flex;">
        <div style="width:50%;border-right: 1px solid #ccc;">
          <div>
            <ul>
              <li style="font-size: 17px;font-family: Source Han Sans CN;font-weight: 400;color: #FFFFFF;">关于链接</li>
            </ul>
          </div>
          <div style="margin-top: 10px;">
            <div v-for='(item,i) in linkList' class="link">
              <a :href=item.articleUrl target="_blank">{{item.title}}</a>
            </div>
          </div>
        </div>
        <div class="aboutPortal">
          <div>
            <ul>
              <li style="font-size: 17px;font-family: Source Han Sans CN;font-weight: 400;color: #FFFFFF;">关于平台</li>
            </ul>
          </div>
          <div style="margin-top: -8px;">
            <ul>
              <li>主办单位：福州市公共资源交易服务中心</li>
              <li>技术支持：福州市勘测院有限公司 </li>
              <li>
                 <span @click="clickFiling">备案号码：闽ICP备18015101号-1</span><img src="~@/assets/portal/filingNum.png"/>网安备案号35010099026-23002
              </li>
              <li>推荐使用Chrome浏览器进行操作浏览，分辨率建议在1440*900以上</li>
            </ul>
          </div>
        </div>
      </div>
      <div style="width: 1150px;margin:0 auto;border-top:1px solid #ccc;"></div>
      <div style="width: 1150px;margin:0 auto;padding:10px 0px;display: flex;margin-top: 15px;">
        <span style="font-size: 13px;font-family: Source Han Sans CN;font-weight: 400;color: #ffffff;margin-left: 80px;">
          Copyright @ 2023 Fuzhou Public Resource Trading Service Center.未经授权，以任何形式复制抄袭本网站内容的个人和单位，本中心将对其追究法律责任
        </span>
        <a href="https://bszs.conac.cn/sitename?method=show&id=1B20FB97B34D5273E06310291AACB5E9" target="_blank"><img src="~@/assets/portal/bottom.png" style="margin-top: -28px;"></a>
      </div>
    </div>
</template>

<script>
  import {newsClassifyCode} from '@constant/portalConfig'
  import {getArticleList} from '@api/portal'

export default {
  name: "bottom",
  components: {},
  data() {
    return {
      linkList:[]
    }
  },
  created () {
    this.linkList = [];
    getArticleList({classifyCode:newsClassifyCode.link,pageNo:1,pageSize:20}).then(res=> {
      this.linkList = res.result.records;
    });
  },
  methods: {
    clickFiling()
    {
        window.open("https://beian.mps.gov.cn/#/query/webSearch", '_blank');
    }
  },
}
</script>
<style lang="less" scoped>
  ul,li{list-style:none;}
  .link{
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #C3C7CD;
    padding: 2px 0px 5px 40px;
    width:50%;float:left;
  }

  .link a{
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #d5d5d5;
  }

  .aboutPortal{
    width:50%;
  }
  .aboutPortal li{
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #d5d5d5;
    padding: 3px;
  }
</style>